// removed by extract-text-webpack-plugin
module.exports = {"glanceBox":"glanceBox__glanceBox___3oyC5","no-max-height":"glanceBox__no-max-height___2r3Zt","green":"glanceBox__green___3TuaW","black":"glanceBox__black___2meQa","yellow":"glanceBox__yellow___1BlgS","red":"glanceBox__red___3yy1W","label":"glanceBox__label___3pimm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/glanceBox/glanceBox.scss
// module id = 1232
// module chunks = 0